/**
 * StackedAvatars Component
 * Overlapping avatar circles with deterministic per-email coloring
 */

import { type CSSProperties, memo, useMemo } from 'react';
import {
  MAX_VISIBLE_AVATARS,
  getAvatarColor,
  getEmailInitials,
} from '@/constants';
import type { StackedAvatarsProps } from '../../types';
import styles from './StackedAvatars.module.css';

export const StackedAvatars = memo(function StackedAvatars({
  invitations,
  maxVisible = MAX_VISIBLE_AVATARS,
}: StackedAvatarsProps) {
  const visibleInvitations = useMemo(
    () => invitations.slice(0, maxVisible),
    [invitations, maxVisible]
  );

  if (invitations.length === 0) {
    return null;
  }

  return (
    <div className={styles.container}>
      {visibleInvitations.map((invitation) => (
        <span
          key={invitation.id}
          className={styles.avatar}
          style={
            {
              '--avatar-bg': getAvatarColor(invitation.email),
            } as CSSProperties
          }
          aria-hidden="true"
        >
          {getEmailInitials(invitation.email)}
        </span>
      ))}
    </div>
  );
});
